import React from 'react';
import { Button } from '@fiverr-private/button';
import { EnvelopeIcon } from '@fiverr-private/visuals';
import { Text } from '@fiverr-private/typography';
import { Center } from '@fiverr-private/layout_components';
import { TranslationKeyWithPrefix, translate } from '../../utils/translate';
import { useIdentificationContext } from '../IdentificationContext';
import { continueWithEmailButtonClass } from './ContinueWithEmailButton.styles.ve.css';

interface ContinueWithEmailButtonProps {
    onClick(): void;
}

export const ContinueWithEmailButton: React.FC<ContinueWithEmailButtonProps> = ({ onClick }) => {
    const { mode } = useIdentificationContext();

    const isSignIn = mode === 'sign_in';

    const textKey: TranslationKeyWithPrefix = isSignIn ? 'social.continue_when_sign_in' : 'social.continue_with_email';

    const handleClick = () => {
        onClick();
    };

    return (
        <Button
            variant="outline"
            intent="primary"
            onClick={handleClick}
            className={continueWithEmailButtonClass}
            fullWidth
        >
            <Center minWidth={20}>
                <EnvelopeIcon size="sm" />
            </Center>
            <Text size="b_md" fontWeight="semibold" color="bodyPrimary" width="100%">
                {translate(textKey)}
            </Text>
        </Button>
    );
};
